import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

type Props = {
  alternative?: boolean;
};
export const MessageSkeleton = ({ alternative }: Props) =>
  alternative ? (
    <ContentLoader
      width={640}
      height={140}
      uniqueKey="conversation-skeleton-message-alt"
      viewBox="0 0 640 140"
      {...DEFAULT_SETTINGS}>
      <circle cx="21" cy="21" r="16" />
      <rect x="60" y="16" rx="0" ry="0" width="130" height="10" />
      <rect x="60" y="36" rx="0" ry="0" width="460" height="10" />
      <rect x="60" y="56" rx="0" ry="0" width="240" height="10" />
      <rect x="60" y="76" rx="0" ry="0" width="340" height="10" />
      <rect x="60" y="106" rx="0" ry="0" width="440" height="10" />
      <rect x="60" y="126" rx="0" ry="0" width="140" height="10" />
    </ContentLoader>
  ) : (
    <ContentLoader
      width={640}
      height={80}
      uniqueKey="conversation-skeleton-message"
      viewBox="0 0 640 70"
      {...DEFAULT_SETTINGS}>
      <circle cx="21" cy="21" r="16" />
      <rect x="60" y="16" rx="0" ry="0" width="90" height="10" />
      <rect x="60" y="36" rx="0" ry="0" width="400" height="10" />
      <rect x="60" y="56" rx="0" ry="0" width="320" height="10" />
    </ContentLoader>
  );
